
<template class="">
  <router-view></router-view>
  <div class="pf ov bgb10 " v-if="$store.state.loader==1" style="z-index: 9999999;">
     <div class="cc c">
      <span class="mainloader"></span>
     </div>
  </div>
  <!-- <div class="pf ov bgb10 " v-if="$store.state.loader==1" style="z-index: 9999999;">
    <img src="@/assets/imgs/loader.gif" alt="" class="cc" style="width: 100px;">
  </div> -->
  <div class="pf ov bgb50 " v-if="$store.state.showPopUp" style="z-index: 9999999;">
    <div class="cc w90 popUp oya" >
      <div v-if="$store.state.apiStatus==true" class="c">
        <img src="@/assets/imgs/reg/check.svg" alt="" class="w100" style="width: 100px;">
        <p class="c-brown-dark fs20">{{ $store.state.popUpMessage }}</p>
        <div class="c mt20"><div class="g_nm w100 goBackButton mt30" @click="close(1)" style="max-width: 200px;">Ok</div></div>
      </div>
      <div v-if="$store.state.apiStatus==false">
        <p class="c-brown-dark fs20">{{ $store.state.popUpMessage }}</p>
        <div class="c mt20"><div class="g_nm w100 goBackButton mt30" @click="close(0)" style="max-width: 200px;">Ok</div></div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "EmptyLayout",
    mounted(){
      const expiretime = 7 * 24 * 60 * 60 * 1000; // days
      const cookiesLang = this.$cookies.get('lang');
      if (cookiesLang) {
        this.$i18n.locale = cookiesLang;
        if(cookiesLang=='ar'){
          $('body').addClass('rtl');
        }
        else{
          $('body').removeClass('rtl');
        }
      } else {
        this.$cookies.set('lang', this.$i18n.locale, expiretime);
      }
    },
    methods:{
      
    }
  }
</script>